import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import PublicRoute from './components/PublicRoute'
import Auth from './components/Auth'
import ResetPassword from './components/ResetPassword'
import MovieList from './pages/MovieList'
import MovieDetail from './pages/MovieDetail'
import WatchHistoryPage from './pages/WatchHistory'

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/login" element={<PublicRoute><Auth onAuthSuccess={() => window.location.href = '/'} /></PublicRoute>} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/" element={<MovieList />} />
            <Route path="/movie/:title/:episode?" element={<MovieDetail />} />
            <Route path="/history" element={<ProtectedRoute><WatchHistoryPage /></ProtectedRoute>} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
